import { rage } from '~/rage';
import { IModalReply, IModalState, ModalSurface } from '~/shared';

export const useModal = () => {
	const showModal = <T extends IModalState>(
		options: T,
		callback: (result: IModalReply<T>) => void,
	) => {
		rage.modal.showModal(
			{ ...options, surface: ModalSurface.Tablet },
			callback,
		);
	};

	const hideModal = () => {
		rage.modal.replyToCurrentModal({ isAccepted: false });
	};

	return {
		showModal,
		hideModal,
	};
};
